export const EMBEDDINGS_STORE = 'https://withjoy.com/media/raw/paper-embeddings';

// Chosen after testing/calibration
export const FUSE_OPTIONS = {
  ignoreFieldNorm: true,
  ignoreLocation: true,
  threshold: 0.15,
};
export const SIMILARITY_THRESHOLD = 0.44;
